import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`You can add a `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file to your package to make it easy for others to manage and install. Packages published to the registry must contain a `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file.`}</p>
    <p>{`A `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file:`}</p>
    <ul>
      <li parentName="ul">{`lists the packages your project depends on`}</li>
      <li parentName="ul">{`specifies versions of a package that your project
can use using `}<a parentName="li" {...{
          "href": "about-semantic-versioning"
        }}>{`semantic versioning rules`}</a></li>
      <li parentName="ul">{`makes your build reproducible, and therefore easier
to share with other developers`}</li>
    </ul>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` To make your package easier to find on the npm website, we recommend including a custom `}<inlineCode parentName="p">{`description`}</inlineCode>{` in your `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file.`}</p>
    </Note>
    <h2><inlineCode parentName="h2">{`package.json`}</inlineCode>{` fields`}</h2>
    <h3>{`Required `}<inlineCode parentName="h3">{`name`}</inlineCode>{` and `}<inlineCode parentName="h3">{`version`}</inlineCode>{` fields`}</h3>
    <p>{`A `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file must contain `}<inlineCode parentName="p">{`"name"`}</inlineCode>{` and `}<inlineCode parentName="p">{`"version"`}</inlineCode>{` fields.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`"name"`}</inlineCode>{` field contains your package's name, and must be lowercase and one word, and may contain hyphens and underscores.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`"version"`}</inlineCode>{` field must be in the form `}<inlineCode parentName="p">{`x.x.x`}</inlineCode>{` and follow the `}<a parentName="p" {...{
        "href": "about-semantic-versioning"
      }}>{`semantic versioning guidelines`}</a>{`.`}</p>
    <h3>{`Author field`}</h3>
    <p>{`If you want to include package author information in `}<inlineCode parentName="p">{`"author"`}</inlineCode>{` field, use the following format (email and website are both optional):`}</p>
    <pre><code parentName="pre" {...{}}>{`Your Name <email@example.com> (http://example.com)
`}</code></pre>
    <h3>{`Example`}</h3>
    <pre><code parentName="pre" {...{}}>{`{
  "name": "my-awesome-package",
  "version": "1.0.0",
  "author": "Your Name <email@example.com>"
}
`}</code></pre>
    <h2>{`Creating a new `}<inlineCode parentName="h2">{`package.json`}</inlineCode>{` file`}</h2>
    <p>{`You can create a `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file by running a CLI questionnaire or  creating a default `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file.`}</p>
    <h3>{`Running a CLI questionnaire`}</h3>
    <p>{`To create a `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file with values that you supply, use the `}<inlineCode parentName="p">{`npm init`}</inlineCode>{` command.`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`On the command line, navigate to the root directory of your package.`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`cd /path/to/package
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Run the following command:`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`npm init
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Answer the questions in the command line questionnaire.`}</p>
      </li>
    </ol>
    <h4>{`Customizing the `}<inlineCode parentName="h4">{`package.json`}</inlineCode>{` questionnaire`}</h4>
    <p>{`If you expect to create many `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` files, you can customize the questions asked and fields created during the `}<inlineCode parentName="p">{`init`}</inlineCode>{` process so all the `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` files contain a standard set of information.`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`In your home directory, create a file called `}<inlineCode parentName="p">{`.npm-init.js`}</inlineCode>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`To add custom questions, using a text editor, add questions with the `}<inlineCode parentName="p">{`prompt`}</inlineCode>{` function:`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`module.exports = prompt("what's your favorite flavor of ice cream, buddy?", "I LIKE THEM ALL");
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`To add custom fields, using a text editor, add desired fields to the `}<inlineCode parentName="p">{`.npm-init.js`}</inlineCode>{` file:`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`module.exports = {
  customField: 'Example custom field',
  otherCustomField: 'This example field is really cool'
}
`}</code></pre>
      </li>
    </ol>
    <p>{`To learn more about creating advanced `}<inlineCode parentName="p">{`npm init`}</inlineCode>{` customizations, see the `}<a parentName="p" {...{
        "href": "https://github.com/npm/init-package-json"
      }}>{`init-package-json`}</a>{` GitHub repository.`}</p>
    <h3>{`Creating a default `}<inlineCode parentName="h3">{`package.json`}</inlineCode>{` file`}</h3>
    <p>{`To create a default `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` using information extracted from the current directory, use the `}<inlineCode parentName="p">{`npm init`}</inlineCode>{` command with the `}<inlineCode parentName="p">{`--yes`}</inlineCode>{`
or `}<inlineCode parentName="p">{`-y`}</inlineCode>{` flag. For a list of default values, see "`}<a parentName="p" {...{
        "href": "#default-values-extracted-from-the-current-directory"
      }}>{`Default values extracted from the current directory`}</a>{`".`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`On the command line, navigate to the root directory of your package.`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`cd /path/to/package
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Run the following command:`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`npm init --yes
`}</code></pre>
      </li>
    </ol>
    <h4>{`Example`}</h4>
    <pre><code parentName="pre" {...{}}>{`> npm init --yes
Wrote to /home/monatheoctocat/my_package/package.json:

{
  "name": "my_package",
  "description": "",
  "version": "1.0.0",
  "scripts": {
    "test": "echo \\"Error: no test specified\\" && exit 1"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/monatheoctocat/my_package.git"
  },
  "keywords": [],
  "author": "",
  "license": "ISC",
  "bugs": {
    "url": "https://github.com/monatheoctocat/my_package/issues"
  },
  "homepage": "https://github.com/monatheoctocat/my_package"
}
`}</code></pre>
    <h4>{`Default values extracted from the current directory`}</h4>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`name`}</inlineCode>{`: the current directory name`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`version`}</inlineCode>{`: always `}<inlineCode parentName="li">{`1.0.0`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`description`}</inlineCode>{`: info from the README, or an empty string `}<inlineCode parentName="li">{`""`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`scripts`}</inlineCode>{`: by default creates an empty `}<inlineCode parentName="li">{`test`}</inlineCode>{` script`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`keywords`}</inlineCode>{`: empty`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`author`}</inlineCode>{`: empty`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`license`}</inlineCode>{`: `}<a parentName="li" {...{
          "href": "https://opensource.org/licenses/ISC"
        }}><inlineCode parentName="a">{`ISC`}</inlineCode></a></li>
      <li parentName="ul"><inlineCode parentName="li">{`bugs`}</inlineCode>{`: information from the current directory, if present`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`homepage`}</inlineCode>{`: information from the current directory, if present`}</li>
    </ul>
    <h3>{`Setting config options for the init command`}</h3>
    <p>{`You can set default config options for the init command. For example, to set the default author email, author name, and license, on the command line, run the following commands:`}</p>
    <pre><code parentName="pre" {...{}}>{`> npm set init-author-email "example-user@example.com"
> npm set init-author-name "example_user"
> npm set init-license "MIT"
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      